/* global $:false */
/*
  Mixin used to move some meta tags used for SEO just after
  header's title node. Supposedly it affects prerender.io.
 */
const headerTagsMixin = {
  methods: {
    reorganizeTags() {
      setTimeout(() => {
        if (!window.$) return;
        $('meta[name="description"]').detach().insertAfter('title');
        $('meta[itemprop]').detach().insertAfter('title');
        $('meta[property]').detach().insertAfter('title');
      }, 0);
    },
  },
};

export default headerTagsMixin;
